import enviroment from './enviroment';
import { io } from 'socket.io-client';

export const socket = io(enviroment.URL_SOCKET, {
    autoConnect: true,
});